export class DeliveryInstructionsData {
  id: number;
  productLine: string;
  contactType: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  deliveryCodes: Array<string> = [];
  lineErrors = new LineError();
  lineError = false;
  toBeValidated = false;
  isActive = false;
  contactId: number;
  sarEmail: string;
}

export class LineError {
  itemId: number;
  errors: Array<string> = [];
}
export class DeliveryInstructionFormsData {
  accountNumber: number;
  updatedBy: string;
  dateUpdated: string;
  deliveryInstructionsData: Array<DeliveryInstructionsData> = [];
}
// Class model for delivery instruction master drop down
export class DeliveryInstructionMaster {
  DeliveryCode: string;
  Description: string;
}

// Class model for delivery instruction master drop down
export class DeliveryInstructionProductLine {
  ProductLineId: string;
  Description: string;
}
/* export var ContactType = [{ id: "P", value: "Primary" }, { id: "S", value: "Secondary" }]*/
export var ContactType = [{ id: 'P', value: 'Primary' }, { id: 'A1', value: 'Alternate 1' },
{ id: 'A2', value: 'Alternate 2' }, { id: 'A3', value: 'Alternate 3' },
{ id: 'A4', value: 'Alternate 4' }, { id: 'A5', value: 'Alternate 5' },
{ id: 'A6', value: 'Alternate 6' }, { id: 'A7', value: 'Alternate 7' },
{ id: 'A8', value: 'Alternate 8' }, { id: 'A9', value: 'Alternate 9' }];
export var DeliveryCodeList = [{ deliveryInstructionsCodeId: 'PJK', DeliveryCodes: 'Pallet Jack Required' }, { deliveryInstructionsCodeId: 'DAR', DeliveryCodes: 'Driver Assistance Required' }, { deliveryInstructionsCodeId: 'UMMAN', DeliveryCodes: 'Unmanned Loacation' }];
